import { AbstractControl, ValidationErrors } from "@angular/forms";
import { IDateOption } from "../models/date-option.interface";

export function SearchDateValidator(control: AbstractControl): ValidationErrors | null {
  const date: IDateOption = control.value;

  if (!date.query) {
    return { error: 'Error'}
  }

  return null;
}
